import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Copy, CheckCircle2, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

/**
 * Modal that shows a freshly-generated password ONCE for the admin to copy
 * and securely deliver to the new user. Closed only via explicit user action.
 */
export default function PasswordModal({ open, onClose, email, password, title = "Käyttäjän tunnukset luotu" }) {
  const [copied, setCopied] = useState(false);
  const copyAll = () => {
    navigator.clipboard.writeText(`Tunnukset Apps2Go Hubiin\n\nSähköposti: ${email}\nSalasana: ${password}\n\nKirjaudu osoitteessa: ${window.location.origin}/login`);
    setCopied(true);
    toast.success("Tunnukset kopioitu leikepöydälle");
    setTimeout(() => setCopied(false), 3000);
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent className="max-w-md" data-testid="password-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle2 className="w-5 h-5 text-emerald-400" /> {title}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-3 flex gap-2 text-xs text-amber-200">
            <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />
            <p>
              <strong>Tärkeää:</strong> Tämä salasana näytetään vain kerran. Tallenna tai välitä se
              käyttäjälle nyt. Voit nollata salasanan myöhemmin "Nollaa salasana" -toiminnolla.
            </p>
          </div>
          <div className="rounded-lg bg-zinc-900/60 p-4 space-y-2">
            <p className="text-[10px] uppercase tracking-widest text-muted-foreground">Sähköposti</p>
            <p className="font-mono text-sm" data-testid="modal-email">{email}</p>
            <p className="text-[10px] uppercase tracking-widest text-muted-foreground pt-2">Salasana</p>
            <p className="font-mono text-lg font-bold tracking-wider text-amber-300" data-testid="modal-password">{password}</p>
          </div>
          <div className="flex gap-2">
            <Button onClick={copyAll} className="flex-1 gap-2 bg-amber-500 hover:bg-amber-400 text-zinc-900" data-testid="modal-copy">
              <Copy className="w-4 h-4" /> {copied ? "Kopioitu!" : "Kopioi tunnukset"}
            </Button>
            <Button variant="outline" onClick={onClose} data-testid="modal-close">
              Sulje
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
